import _ from 'lodash';
import { useDayjs } from '../packages/directive/day';

const adbDayjs = useDayjs();
// query => filters => query => setQuery;
//       1    a    2         3
// 1: 根据type添加默认值；
// 2：根据type,校验数据=> if (error){添加错误信息}else{清理默认值}
// 3: 组装排序生成query;
// a: reset

// pipe map映射{type:value}
// type: undefined|array|never[]
function pipeMapConditionOfValue(value, mapConditionValue) {
  const isUndefined = _.isUndefined(value);
  if (isUndefined) {
    return mapConditionValue.undefined;
  }
  if (_.isArray(value)) {
    if (value.length) {
      return value.every((amount) => !amount)
        ? mapConditionValue['never[]']
        : mapConditionValue.array;
    }
    return mapConditionValue['never[]'];
  }
  return mapConditionValue.value;
}

// a[fun]根据type, reset value
export function resetItem(type) {
  let value;
  switch (type) {
    case 'radio':
      value = undefined;
      break;
    case 'checkbox':
      value = [];
      break;
    case 'amount-range':
      value = [undefined, undefined];
      break;
    case 'number-range':
      value = [undefined, undefined];
      break;
    case 'date-picker':
      value = [undefined, undefined];
      break;
    default:
      break;
  }
  return value;
}

// a: reset
export function resetDate(filterOptions, filters = {}) {
  return _.reduce(
    filterOptions,
    (data, option) => {
      // 从route.query获取无效参数时生成默认值----依据type生成；
      // checkbox: [];
      // 待完善;
      const value = resetItem(option.type);
      data[option.key] = value;
      return data;
    },
    filters
  );
}

// 1[fun]根据type获取默认值
export function getItemByQuery(value, type) {
  let newVal;
  const isUndefined = _.isUndefined(value);
  switch (type) {
    case 'radio':
      if (isUndefined) {
        newVal = undefined;
      } else {
        newVal = value;
      }
      break;
    case 'select':
      if (isUndefined) {
        newVal = [undefined];
      } else if (typeof value === 'string') {
        newVal = value;
      } else {
        newVal = [`${value}`];
      }
      break;
    case 'checkbox':
      if (isUndefined) {
        newVal = [];
      } else if (typeof value === 'string') {
        newVal = value.split(',');
      } else if (typeof value === 'number') {
        newVal = [`${value}`];
      }
      break;
    case 'amount-range':
      if (isUndefined) {
        newVal = [undefined, undefined];
      } else {
        value += '';
        newVal =
          typeof value === 'string' &&
          value.split(',').map((d) => (d === '' ? undefined : d));
      }
      break;
    case 'number-range':
      if (isUndefined) {
        newVal = [undefined, undefined];
      } else {
        value += '';
        newVal =
          typeof value === 'string' &&
          value.split(',').map((d) => (d === '' ? undefined : d));
      }
      break;
    case 'date-picker':
      if (isUndefined) {
        newVal = [undefined, undefined];
      } else {
        newVal =
          typeof value === 'string' &&
          value.split(',').map((d) => (d === '' ? undefined : new Date(d)));
      }
      break;
    default:
      if (isUndefined) {
        newVal = undefined;
      } else {
        newVal = value;
      }
      break;
  }
  return newVal;
}

// 1
export function getDateForQuery(query, filterOptions) {
  const q = _.reduce(
    filterOptions,
    (data, option) => {
      // 从route.query获取无效参数时生成默认值----依据type生成；
      // checkbox: [];
      // 待完善;
      const value = getItemByQuery(query[option.key], option.type);
      data[option.key] = value;
      return data;
    },
    {}
  );
  return _.pick(q, _.map(filterOptions, 'key'));
}

// 2
export function formatDate2ViewDate(filters, options) {
  return _.mapValues(filters, (value, key) => {
    const option = _.find(options, (option) => option.key === key);
    if (!option) return {};
    // const isUndefined = _.isUndefined(value);

    switch (option.type) {
      case 'radio':
        value = pipeMapConditionOfValue(value, {
          undefined,
          value,
        });
        break;
      case 'checkbox':
        value = pipeMapConditionOfValue(value, {
          undefined,
          array: _.isArray(value) && value.join(','),
          'never[]': undefined,
        });
        break;
      case 'amount-range':
        value = pipeMapConditionOfValue(value, {
          undefined,
          array: _.isArray(value) && value.join(','),
          'never[]': undefined,
        });
        break;
      case 'number-range':
        value = pipeMapConditionOfValue(value, {
          undefined,
          array: _.isArray(value) && value.join(','),
          'never[]': undefined,
        });
        break;
      case 'date-picker':
        value = pipeMapConditionOfValue(value, {
          undefined,
          array:
            _.isArray(value) &&
            value.map((date) => date && new Date(date).toISOString()).join(','),
          'never[]': undefined,
        });
        break;
      default:
        break;
    }
    return value;
  });
}

// 3
export function setStrqueryForData(filterOptions, f, query) {
  const keys = _.map(filterOptions, 'key');
  return _.chain(query).omit(keys).merge(f).value();
}

export function transactionParams(filterOptions, f, query) {
  query = query || {};
  return setStrqueryForData(
    filterOptions,
    formatDate2ViewDate(f, filterOptions),
    query
  );
}

export function initFilters(filterOptions, filters, fnFormat) {
  return _.reduce(
    filterOptions,
    (pre, cur) => {
      let cuValue = filters ? filters[cur.key] : undefined;
      if (cuValue) {
        const cuFormat = fnFormat && fnFormat[cur.key];
        cuValue = cuFormat ? cuFormat(filters[cur.key]) : filters[cur.key];
      } else {
        cuValue = resetItem(cur.type);
      }
      pre[cur.key] = cuValue;
      return pre;
    },
    {}
  );
}
const dictFormat = {
  checkbox: (value) => value.join(','),
  'amount-range': (value) => value.join(','),
  'number-range': (value) => value.join(','),
  radio: (value) => value,
  'date-picker': (value) =>
    value.map((date) => adbDayjs.dayjs(date).toISOString()).join(','),
  select: (value) => value,
};

export function getParamsForFilters(filterOptions, filters, fnFormat) {
  return _.reduce(
    filterOptions,
    (pre, cur) => {
      let cuValue = filters[cur.key];
      if (!cuValue) {
      } else if (_.isEqual(cuValue, resetItem(cur.type))) {
        cuValue = undefined;
      } else {
        let cuFormat = dictFormat[cur.type] || ((value) => value);
        fnFormat && fnFormat[cur.key] && (cuFormat = fnFormat[cur.key]);
        cuValue = cuFormat ? cuFormat(cuValue) : cuValue;
      }
      pre[cur.key] = cuValue;
      return pre;
    },
    {}
  );
}
